import { observable, action, configure } from 'mobx';

configure({ enforceActions: 'observed' }) // don't allow state modifications outside actions

class BaseStore {
	@observable items = []
	@observable isLoading = false;
	@observable dirty = false;
	auth = null;
	skipUpdateLocalItem = false;

	constructor(opts) {
		this.baseModel = opts.model;

		if (opts.auth){
			this.auth = opts.auth;
		}
	}

	@action.bound setItems(items){
		this.items = [];
		this.items.push.apply(this.items, items.map( item => new this.baseModel(item) ));
	}

	@action.bound load(opt) {
		console.log('fetching...');
		this.isLoading = true;
		return this.loadImplementation(opt).then( action((items) => {
			this.isLoading = false;
			this.dirty = false;
			return items;
		}) ).catch( action((err) => {
			this.isLoading = false;
			throw err;
		}) );
	}

	insert(values) {
		return this.insertImplementation(values).then( action((item) => {
			this.dirty = true;
			return item;
		}) );
	}

	update(values){
		return this.updateImplementation(values).then( (item) => {
			if (item && !this.skipUpdateLocalItem){
				this.updateLocalItem(item);
			}
			return item;
		});
	}

	@action.bound updateLocalItem(values){
		if (!this.baseModel.properties){
			throw new Error('the base model should have a static "properties" defined');
		}
		let filtered = this.items.filter( (item) => item.id == values.id );	
		filtered.forEach( item => {
			this.baseModel.properties.forEach( key => {
				item[key] = values[key];
			});
		});
	}

	delete(id) {
		return this.deleteImplementation(id).then( () => {
			this.deleteLocalItem(id);
			return id;
		});
	}

	@action.bound deleteLocalItem(id) {
		let index = this.items.findIndex( (item) => item.id == id );
		if (index != -1){
			this.items.splice(index, 1);
		}
	}
}

export default BaseStore;

